import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";

export default function RadioGroup({
    name,
    control,
    label,
    options,
    primaryColor = "blue",
}) {
    return (
        <div className="flex flex-col gap-2">
            {label && (
                <label className="text-sm font-medium text-gray-700">{label}</label>
            )}

            <div className="flex gap-6">
                {options.map((option) => (
                    <Controller
                        key={option.value}
                        name={name}
                        control={control}
                        render={({ field }) => (
                            <label
                                htmlFor={`${name}-${option.value}`}
                                className={`flex items-center gap-2 cursor-pointer select-none transition-colors ${field.value === option.value
                                        ? "text-primary"
                                        : "text-gray-700"
                                    }`}
                            >
                                <input
                                    {...field}
                                    id={`${name}-${option.value}`}
                                    type="radio"
                                    value={option.value}
                                    checked={field.value === option.value}
                                    onChange={() => field.onChange(option.value)}
                                    className={`w-4 h-4 text-${primaryColor}-600 border-gray-300 focus:ring-${primaryColor}-500`}
                                />
                                <span className="text-sm">{option.label}</span>
                            </label>
                        )}
                    />
                ))}
            </div>
        </div>
    );
}

/** ✅ Validación de props con PropTypes */
RadioGroup.propTypes = {
    name: PropTypes.string.isRequired,
    control: PropTypes.object.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    primaryColor: PropTypes.string,
};